import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PlanMarker } from '../models/plan-marker.interface';
import { RoomIndicator } from '../models/plan-marker.interface';
import { environment } from '../../../../environments/environment';

export interface IndicatorDetailDialogData {
  marker: PlanMarker;
  indicator: RoomIndicator;
}

@Component({
  selector: 'app-indicator-detail-dialog',
  templateUrl: './indicator-detail-dialog.component.html',
  styleUrls: ['./indicator-detail-dialog.component.scss']
})
export class IndicatorDetailDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<IndicatorDetailDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IndicatorDetailDialogData
  ) {}

  getIndicatorSymbolUrl(indicator: RoomIndicator): string | null {
    if (!indicator.indikator?.symbol_id) return null;
    const key = (environment as any).indikatorSymbolMap?.[indicator.indikator.symbol_id];
    if (!key) return null;
    const base = (environment as any).indikatorSymbolBasePath || '/assets/symbols';
    return `${base}/${key}.svg`;
  }

  getIndicatorSymbolColor(indicator: RoomIndicator): string | null {
    if (!indicator.indikator?.symbol_id) return null;
    const colorMap = (environment as any).indikatorSymbolColorMap || {};
    return colorMap[indicator.indikator.symbol_id] || null;
  }

  getFormattedIndicatorNumber(indikatorNumber: number | null | undefined): string {
    if (indikatorNumber === null || indikatorNumber === undefined) {
      return '-';
    }
    return indikatorNumber.toString().padStart(3, '0');
  }

  formatSchwellenwertAsInteger(schwellenwert: number | null | undefined): string {
    if (schwellenwert === null || schwellenwert === undefined) {
      return '-';
    }
    return Math.round(schwellenwert).toString();
  }

  // Expose Math to template
  Math = Math;

  getSystemtypCaption(): string | null {
    return (this.data.indicator as any).systemtyp_caption || null;
  }

  getSystemgruppeCaption(): string | null {
    return (this.data.indicator as any).systemgruppe_caption || null;
  }

  getIndikatorCode(): string {
    return (this.data.indicator.indikator as any)?.code || this.data.indicator.indikator?.name || 'Unbekannt';
  }

  onClose(): void {
    this.dialogRef.close();
  }
}



